import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.select = this.element.matches("select") ? this.element : this.element.querySelector("select")
    this.change = this.change.bind(this)
    this.select.addEventListener("change", this.change)
  }

  disconnect() {
    this.select?.removeEventListener("change", this.change)
  }

  change(event) {
    if (!event.target.value) return

    // 财务寄送
    $("#courier-recipient-panel").collapse(event.target.value === "20" ? "show" : "hide")
  }
}
